module.exports = __webpack_public_path__ + "img/走流程删除.5798ba5b.svg";